import React from "react";

export default function Header() {
  return (
    <header className="ui centered">
      <h1 className="ui center">CHORE TRACKER</h1>
    </header>
  );
}